import type { UIField } from 'payload'

import React from 'react'

import { LinkToDocClient } from './index.client.js'

export const LinkToDoc: React.FC<UIField> = () => {
  return <LinkToDocClient />
}
